import * as React from 'react'
import { createStyles, Theme, WithStyles, withStyles, Typography, Table, TableBody, TableRow, TableCell, Chip } from '@material-ui/core'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import { compose } from 'redux'
import { withRouter, RouteComponentProps } from 'react-router'
import { RootState } from 'src/core/redux/reducer'
import { connect } from 'react-redux'
import { WithGlobalProgress } from 'src/type/lib/withGlobalProgress'
import { WithToast, withToast } from 'src/shared/Toast/Toast'
import { replaceDetteWithTaux } from 'src/shared/utils/helpers'
import autobind from 'autobind-decorator'
import DashboardPanel from 'src/page/Consumer/Dashboard/DashboardPanel'

const styles = (t: Theme) => createStyles({
  chip: {
    margin: '4px',
    fontSize: '0.75rem',
    height: '26px'
  },
  typo: {
    padding: '4px 0'
  },
})

interface IProps extends WithI18n,
  WithGlobalProgress,
  WithToast,
  RouteComponentProps<any>,
  WithStyles<typeof styles>,
  ReturnType<typeof state2props> {
}

class DashboardHabilitations extends React.Component<IProps, {}> {

  render() {
    const { t, classes, enterprise, user } = this.props
    return (
      <DashboardPanel
        label={t.my_clearances}
        icon={user.read_only_access === false ? "business" : "preview"}
        redirect="enterprise"
      >
        {enterprise &&
          <Table>
            <TableBody>
              <TableRow>
                <TableCell style={{ width: '180px' }}>
                  <Typography variant="body2" className={classes.typo}>{t.EnterpriseDetail_info_general_habilitations_caption}</Typography>
                </TableCell>
                <TableCell>
                  {this.renderHabilitations()}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell style={{ width: '180px' }}>
                  <Typography variant="body2" className={classes.typo}>{t.EnterpriseDetail_info_general_mandataire}</Typography>
                </TableCell>
                <TableCell>
                  {enterprise.is_mandataire !== undefined ?
                    (<Chip label={enterprise.is_mandataire ? t.yes : t.no} className={classes.chip} />) :
                    (<Typography variant="body2" className={classes.typo}>{t.not_available}</Typography>)
                  }
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        }
      </DashboardPanel>

    )
  }

  @autobind
  private renderHabilitations() {
    const { enterprise, t, classes } = this.props;
    if (enterprise && enterprise.habilitations) {
      return enterprise.habilitations.split(",").map((h: string, i: number) => {
        return (
          <Chip key={h} label={replaceDetteWithTaux(h.charAt(0).toUpperCase() + h.slice(1))} className={classes.chip} />
        )
      })
    } else return t.not_available;
  }
}

const state2props = (state: RootState) => ({
  mapName: state.utils.mapCategories,
  mapProductType: state.utils.mapProductType,
  news: state.paginate.news.entities,
  user: state.accountInfo.connectedUser,
  enterprise: state.accountInfo.enterpriseSelected,
});

export default compose(
  withI18n,
  withRouter,
  withToast,
  withStyles(styles),
  connect(state2props),
)(DashboardHabilitations)



// WEBPACK FOOTER //
// ./src/page/Consumer/Dashboard/tabs/DashboardHabilitations.tsx